<template>
  <div class="col-lg-12" style="padding: 20px 30px">
    <div class="main-card mb-3 card">
      <div class="card-body">
        <h5 class="card-title">
          메시지발송내역
          <div
            class="sub_title"
            style="
              margin-bottom: 20px;
              color: #333;
              font-size: 13px;
              border: 1px solid #ccc;
              background: #f8f8f8;
              height: 30px;
              text-align: right;
              position: absolute;
              right: 20px;
              top: 10px;
              padding: 2px 10px;
            "
          >
            회원관리 → 메시지발송내역
          </div>
        </h5>
        <query-grid :config="config" ref="qg">
          <template #items="props">
            <tr
              v-for="record in props.records"
              v-bind:key="record.id"
              :class="{ 'table-danger': record.is_deleted }"
            >
            <td style="text-align: center">
                <ImsDetail :ImsDetail="record" :ref="'admusr' + record.seqNo" />
              </td>
               <td style="text-align: center">
                {{ record.username }}
               </td>
               <td style="text-align: center">
                <Student :student="record" />
              </td>
              <td
                style="text-align: center"
                v-if="
                  this.$root.guiPerm != 'CLASS' &&
                  this.$root.guiPerm != 'ENTERPRISE'
                "
              >
                <Business v-if="record.t2" :biz="record.t2" />
              </td>
               <td style="text-align: center">
                {{ record.etc3 }}
               </td>
               <td style="text-align: center">
                {{ record.callphone }}
               </td>
               <td style="text-align: center">
                {{ record.intime }}
               </td>
               <td style="text-align: center">
                {{ record.reqtime }}
               </td>
               <td style="text-align: center">
                {{ record.senttime }}
               </td>
               <td style="text-align: center">
                {{ resultText(record.result) }}
               </td>
               <td>
                <button
                  class="btn btn-warning btn-sm"
                  @click="this.$refs['admusr' + record.seqNo][0].openImsModal()"
                >
                  상세
                </button>
              </td>
            </tr>
          </template>
        </query-grid>
      </div>
    </div>
  </div>

  <Tree
    :key="$route.path"
    :tree-data="this.$root.businesses"
    :selectable="['CLASS']"
    render-button
    :callback="selectedBiz"
    :selectedNode="{ id: selData.activeBusiness }"
    ref="biz"
  />
</template>

<script>
// @ is an alias to /src

import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid_IMS";
import Student from "../components/detail_pages/Student";
import ImsDetail from "../components/detail_pages/ImsDetail";
export default {
  name: "Home",
  components: {
    Tree,
    treeBtn,
    Business,
    ImsDetail,
    Student,
    QueryGrid,
  },
  props: {
    msg: String
  },
  mounted() {
    if (this.$route.query.type) {
      /*this.typeFilter = {};
        this.typeFilter[this.$route.query.type] = true;*/
      this.$refs.qg.pushSetting(
        "status_filter_" + this.$route.query.type,
        true
      );
    }

    if (this.$root.guiPerm == "CLASS" || this.$root.guiPerm == "ENTERPRISE") {
      this.$refs.qg.pushSetting("status_filter_ACTIVE", true);
      this.config.columns.splice(3, 1);
    }

    this.$refs.qg.search();

    this.$watch(
      () => this.$route.query.type,
      function (toQuery, previousQuery) {
        // react to route changes...

        this.$refs.qg.pushSetting("status_filter_ACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_INACTIVE", false);
        this.$refs.qg.pushSetting("status_filter_EVENT", false);
        if (toQuery)
          this.$refs.qg.pushSetting("status_filter_" + toQuery, true);

        this.$refs.qg.search();
      }
    );
  },
  methods: {
    doChange(name, value) {
      if (this.selData[name] === value) {
        delete this.changedData[name];
      } else {
        this.changedData[name] = value;
      }
    },
    selectedBiz(biz) {
      this.selBiz = biz;
      this.changedData.activeBusiness = biz.id;
    },
    doSend() {
      // 업데이트일 경우 patch /businesses/번호
      // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
      var data = {};
      if (this.creating) {
        data = {
          ...this.selData,
          ...this.changedData,
          activeBusiness: this.selBiz.id,
          product: this.selProduct.id,
          paymentMethod: this.selData.payMethod,
          hopeStart: this.selData.hopeStart,
          level: this.selData.level,
        };
      } else {
        data = this.changedData;
      }
      axios({
        method: this.creating ? "post" : "patch",
        url: "/students" + (!this.creating ? "/" + this.selData.id : ""),
        data: data,
      }).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.$refs.qg.search();
          $.notify(
            {
              // options
              message: "학생 생성이 처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );
          bootstrap.Modal.getInstance(
            document.getElementById("studentModal")
          ).hide();
          if (this.selData.addSubscription) {
            $.notify(
              {
                // options
                message: "아이디 생성을 처리중입니다",
              },
              {
                // settings
                type: "info",
                z_index: 9999,
              }
            );

            axios
              .post("/subscriptions", {
                student: response.data.id,
                product: this.selProduct.id,
                paymentMethod: this.selData.payMethod,
                hopeStart: this.selData.hopeStart,
                level: this.selData.level,
              })
              .then((response) => {
                if (response.data.error) {
                  $.notify(
                    {
                      // options
                      message: "ID 추가 실패: " + response.data.error,
                    },
                    {
                      // settings
                      type: "danger",
                      z_index: 9999,
                    }
                  );
                } else {
                  if (
                    confirm(
                      "아이디까지 같이 신청이 완료되었습니다. 결제창으로 이동할까요?"
                    )
                  ) {
                    this.$router.push("/subscriptions?id=" + response.data.id);
                  } else {
                    this.$refs.qg.search();
                    $.notify(
                      {
                        // options
                        message: "아이디 신청되었습니다.",
                      },
                      {
                        // settings
                        type: "success",
                        z_index: 9999,
                      }
                    );
                  }
                }
              });
          }
        }
      });
    },
    fetchProducts(source) {
      var extras = "?";
      if (source) {
        extras += "source=" + source.id;
      }
      axios.get("/products" + extras).then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.products = response.data.result;
        }
      });
    },

    fetchSubscriptions(student) {
      var extras = "";
      //this.levelRequest.record = {};
      axios
        .get('/subscriptions?status_filter=["ACTIVE"]&student=' + student.id)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            student.subscriptions = response.data.result.filter(
              (x) => x.product == "ChildU"
            );
          }
        });
    },
    addHistory() {
      var data = {
        h_date: this.hSetDate,
        DateDi: this.DateDi,
        intMemberID: this.selData.id,
      };
      var send = axios({
        method: "post",
        url: "/studies/historysave",
        data: data,
      });

      console.log(this.hSetDate);

      send.then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "처리할 수 없습니다 " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          $.notify(
            {
              // options
              message: "처리되었습니다",
            },
            {
              // settings
              type: "success",
              z_index: 9999,
            }
          );

          this.$router.push(
            this.creating
              ? response.data.id.toString()
              : "../" + response.data.id.toString()
          );
        }
      });
    },
    fetchSubscriptionsChecked() {
      this.$refs.qg.checked.forEach((s) => {
        this.fetchSubscriptions(s);
      });
    },
    getDiff(value) {
      var moment = require("moment"); // moment 모듈불러오기

      const diff = moment().diff(value, "hours");
      const days = Math.floor(diff / 24);
      const hours = diff % 24;

      return -days;
    },
    getCurrent(reset, intMemberID, username, hanName, s_name, n_name) {
      //if(reset){
      this.selData = {
        id: intMemberID,
        username: username,
        hanName: hanName,
        activeBusiness: s_name,
        Business: n_name,
      };
      //console.log(this.selData)
      //}
    },
    creatingMode() {
      this.selData = {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
      };
      this.creating = true;
      this.changedData = {};
    },
    nvl(str) {
      if (typeof str == "undefined" || str == null) str = defaultStr;
      return str;
    },
  },
  filters: {
    currency(value) {
      return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  computed: {
    resultText() {
      return function(result) {
        switch (result) {
            case '0':
                return '대기';
            case '1':
                return '모듈에서 읽은 상태';
            case 'Y':
                return '발송 요청 성공';
            case 'N':
                return '발송 요청 실패';
            case '2':
                return '발송 최종 성공';
            case '4':
                return '발송 최종 실패';
            default:
                return result; // 알 수 없는 상태의 경우 기본 값 표시
        }
      }
    }
  },
  data() {
    return {
      config: {
        name: "메시지발송내역",
        req_endpoint: "/businesses/ims/getIMSList",
        default_limit: 20,
        search_fields: [
          {
            id: "businesses",
            name: "소속선택",
            type: "business", // business, date, datetime,
          },
          {
            id: "search",
            name: "키워드검색",
            type: "text",
            placeholder: "아이디/이름",
          },
          {
            id: "search_phone",
            name: "수신번호검색",
            type: "text",
            placeholder: "수신번호",
          },
          {
            id: "date_filter",
            name: "날짜검색",
            type: "date",
            filter_type: {
              intime: "등록일",
              senttime: "발송일",
            },
          },
          {
            id: "status",
            name: "발송상태",
            type: "switch",
            filter_type: {
              0: "대기",
              1: "모듈에서 읽은 상태",
              Y: "발송 요청 성공",
              N: "발송 요청 실패",
              2: "발송 최종 성공",
              4: "발송 최종 실패",
            },
          },
        ],
        columns: [
        {
            id: "seqNo",
            sortable: false,
            name: "seqNo",
            excel_print: (v) => {
              return v.seqNo;
            },
          },
          {
            id: "username",
            sortable: false,
            name: "아이디",
            excel_print: (v) => {
              return v.username;
            },
          },
          {
            id: "hanName",
            sortable: false,
            name: "이름",
            excel_print: (v) => {
              return v.name;
            },
          },
          {
            id: "biz",
            sortable: false,
            name: "학원/캠퍼스",
            excel_print: (v) => {
              return  v.t2.name;
            },
          },
          {
            id: "etc3",
            sortable: false,
            name: "구분",
            excel_print: (v) => {
              return v.etc3;
            },
          },
          {
            id: "callphone",
            sortable: false,
            name: "수신번호",
            excel_print: (v) => {
              return v.callphone;
            },
          },

          {
            id: "intime",
            sortable: false,
            name: "등록일시",
            excel_print: (v) => {
              return v.intime;
            },
          },
          {
            id: "reqtime",
            sortable: false,
            name: "예약일시",
            excel_print: (v) => {
              return v.reqtime;
            },
          },
          {
            id: "senttime",
            sortable: false,
            name: "발송일시",
            excel_print: (v) => {
              return v.senttime;
            },
          },
          {
            id: "result",
            sortable: false,
            name: "발송상태",
            excel_print: (v) => {
              return v.result;
            },
          },
          {
            id: "action",
            name: "관리",
          },
        ],
        disable_init_search: true,
      },
      selBiz: {
        name: "",
      },
      subscriptions: [],
      selData: {
        id: "",
        activeBusiness: "",
        username: "",
        hanName: "",
        Business: "",
      },
      changedData: {},
      selProduct: {},
      selectedSubscription: {
        id: 0,
      },
      products: [],
      creating: true,
    };
  },
};
</script>
